import React from 'react';
import { Heart, Award, Shield, Users } from 'lucide-react';
import { about } from '../data/mock';

const About = () => {
  const features = [
    {
      icon: Heart,
      title: "Amor aos Animais",
      description: "Cada pet é tratado com carinho e respeito"
    },
    {
      icon: Award,
      title: "Excelência",
      description: "Atendimento de alta qualidade"
    },
    {
      icon: Shield,
      title: "Confiança",
      description: "Transparência em todos os procedimentos"
    },
    {
      icon: Users,
      title: "Compromisso",
      description: "Dedicação total ao bem-estar animal"
    }
  ];

  return (
    <section id="about" className="py-20 px-4 bg-gradient-to-br from-purple-100 via-purple-50 to-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Sobre a <span className="text-purple-600">Clínica</span>
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {about.description}
          </p>
        </div>

        {/* Mission */}
        <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-2xl p-8 md:p-12 shadow-xl mb-12 text-white">
          <div className="flex items-start gap-4">
            <div className="bg-white/20 rounded-full p-4 backdrop-blur-sm">
              <Heart className="w-8 h-8 text-white" />
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-3">Nossa Missão</h3>
              <p className="text-purple-50 text-lg leading-relaxed">
                {about.mission}
              </p>
            </div>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-2xl transition-all duration-300 text-center group border-2 border-purple-100 hover:border-purple-400"
              >
                <div className="bg-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h4>
                <p className="text-gray-600 text-sm">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;